import { i18n } from '@/commons/utils';
import { getURLParameters } from '../customer-utils';


const RESET_PASSWORD = 'rest/model/atg/userprofiling/ProfileActor/passwordReinit';

export const init = () => {
  const form = cube.$id('js-reset-password');

  validator(form);

  form.on('submit', resetPassword);
};


/**
 * Display an error if the XHR returns error(s).
 *
 * @param {Json} response The XHR response.
 * @param {HTMLElement} button The form submit button.
 * @returns {Boolean}
 */
const ajaxError = (response, button) => {
  if (
    typeof response === 'string' ||
    typeof response === 'object' && response.responseTO && response.responseTO.errors[0] && response.responseTO.errors[0].message
  ) {
    if (response === 'string')
      cube.alert.error(i18n('error.oc.call'));
    else
      cube.alert.error(response.responseTO.errors[0].message);

    button.disabled = false;

    return true;
  }

  return false;
};


/**
 * Update the customer's password if the XHR returns no error.
 *
 * @param {Json} response The XHR response.
 * @param {HTMLElement} button The form submit button.
 */
const resetPasswordSuccess = (response, button) => {
  if (ajaxError(response, button))
    return;

  cube.alert.success(i18n('profile.changesSaved'));

  setTimeout(() => {
    window.location.href = '/';
  }, 2000);
};


/**
 * Send an XHR to update the customer's password if the new password has a good format.
 *
 * @param {Event} e
 */
function resetPassword (e) {
  e.preventDefault();

  if ($(this).valid()) {
    const button = cube.$id('js-reset-password-button');
    const password = cube.$id('password');

    const parameters = Object.assign(
      { newPassword: password.value },
      getURLParameters(window.location.search)
    );

    button.disabled = true;

    cube.ajax.post(
      RESET_PASSWORD,
      parameters
    )
      .onSuccess(response => resetPasswordSuccess(response, button))
      .onError(response => ajaxError(response, button))
      .call();
  }
}


const validator = form => {
  $(form).validate(Object.assign(
    $.validator.cubeOptions,
    {
      rules: {
        password: {
          passwordCheck: true
        },

        confirmPassword: {
          equalTo: '#password'
        }
      },
      message: {
        password: {
          required: i18n('profile.updatePassword.newpassword.required'),
          minlength: i18n('profile.updatePassword.newpassword.minLength')
        },
        confirmPassword: {
          required: i18n('profile.updatePassword.confirmPassword.required'),
          minlength: i18n('profile.updatePassword.newpassword.minLength'),
          equalTo: i18n('profile.updatePassword.confirmPassword.equalsTo')
        }
      }
    }
  ));
};


// WEBPACK FOOTER //
// ./src/customer/authentication/authentication-reset-password.js